module.exports = __webpack_public_path__ + "static/media/gameZoo.44285b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameZoo.png
// module id = 2523
// module chunks = 0